<template>
<div>
  <el-breadcrumb separator=">" class="bread-crumb">
    <el-breadcrumb-item :to="{ path: '/advancepayment/manager' }">进货款管理</el-breadcrumb-item>
    <el-breadcrumb-item>充值</el-breadcrumb-item>
  </el-breadcrumb>
  <div class="white-box content" v-if="!succ"> 
    <p class="title">请将进货款转账至</p>
    <div class="account-info">
      <p>
        <span class="label">银行账号</span>
        <span class="value">97160154740012579</span>
      </p>
      <p>
        <span class="label">账号名称</span>
        <span class="value">上海证大喜马拉雅网络科技有限公司</span>
      </p>
      <p>
        <span class="label">开户行名称</span>
        <span class="value">上海浦东发展银行张江科技支行</span>
      </p>
    </div>
    <p class="title">填写转账信息</p>
    <el-form 
    ref="ruleForm" 
    :model="ruleForm"
    :rules="formRules"
    label-width="120px" 
    class="form">
      <el-form-item 
      prop="amount"
      label="转账金额">
        <el-input 
        v-model.number="ruleForm.amount"
        class="form-input" 
        placeholder="请填写整数或小数"
        ></el-input>
      </el-form-item>
      <el-form-item 
      prop="bankAccountNumber"
      label="转出账号" 
      class="is-required">
        <el-input v-model.string="ruleForm.bankAccountNumber" class="form-input" placeholder="请填写账号"></el-input>
      </el-form-item>
      <el-form-item 
      prop="bankAccountName"
      label="转出账号名称">
        <el-input v-model.string="ruleForm.bankAccountName" class="form-input" placeholder="如上海证大喜马拉雅网络科技有限公司"></el-input>
      </el-form-item>
      <el-form-item class="is-required" label="上传凭证">
        <el-upload
          accept ="image/png,image/jpg,image/jpeg"
          :action="`http://${uploadUrl}/dtres/picture/upload?${uploadParam}`"
          :data="uploadParams"
          list-type="picture-card"
          class="form-upload"
          :on-success="handlePictureChange"
          :on-remove="handleRemove">
          <i class="el-icon-plus"></i>
        </el-upload>
        <p class="tips">上传您的银行或支付宝等渠道的转账回单</p>
        <!-- <el-dialog v-model="dialogVisible" size="tiny">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog> -->
      </el-form-item>
      <p class="title"></p>
      <el-form-item class="form-submit">
        <el-button type="primary" 
        @click="onSubmit" 
        :loading="btnLoading">提交申请</el-button>
      </el-form-item>
    </el-form>
  </div>
  <recharge-success v-else-if="succ"></recharge-success>
</div>
</template>
<script type="text/javascript">
import RechargeSuccess from './rechargeSuccess.vue'
import {postRechargeApply} from 'api'
import {getCookie} from 'utils/cookie'
// import {validateidCardNo} from 'utils/validate'
// const _uid = getCookie('4&_token').split('&')[0]
const _isOnline = window.location.host == 'partner.ximalaya.com'
let _token = _isOnline ? getCookie('1&_token') : getCookie('4&_token')
let _uploadUrl =  _isOnline ? 'upload.ximalaya.com' : 'upload.test.ximalaya.com'

const _params = `token=${encodeURIComponent(_token)}`
export default {
  data () {
    var checkBankCard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('账号不能为空'));
      }
      const pattern = /^([1-9]{1})(\d+)$/ 
      if(!pattern.test(value)) {
        return callback(new Error('请输入正确的转账账号'));
      } else {
        callback();
      }
    }
    return {
      uploadUrl: _uploadUrl,
      uploadParam: _params,
      ruleForm: {
        amount: '', //充值金额  
        bankAccountNumber: '', //银行账户编号  
        bankAccountName: '', //银行账户名称  
        voucher: '', //凭据 
      },
      formRules: {
        amount: [{required: true, message: '转账金额不能为空'},{type: 'number', message: '请输入正确的转账金额', trigger: 'blur'}],
        bankAccountNumber: [{validator: checkBankCard, trigger: 'blur'}],
        bankAccountName: [{required: true, message: '银行账户名称不能为空'}]
      },
      uploadParams: {
        token: _token || ''
      },
      dialogVisible: false,
      // dialogImageUrl: '',
      succ: false,
      fileList: [],
      btnLoading: false
    }
  },
  components: {
    'recharge-success': RechargeSuccess
  },
  methods: {
    handlePictureChange (response, file, fileList) {
      this.$data.fileList = []
      if ( response.ret != 0) {
        this.$message({
          message: response.msg,
          type: 'error'
        })
        return false;
      }
      fileList.forEach((item) => {
        this.$data.fileList.push(item.response.data[0].url)
      })

    },
    handleRemove (file, fileList) {
      this.$data.fileList = []
      fileList.forEach((item) => {
        this.$data.fileList.push(item.response.data[0].url)
      })
    },
    onSubmit () {
      let requestParamter = Object.assign({}, this.$data.ruleForm)
      requestParamter.voucher = this.$data.fileList.toString()      
      const _me = this
      this.$refs.ruleForm.validate((valid) => {
        if (valid && requestParamter.voucher) {
          this.$data.btnLoading = true
          console.log({...requestParamter})
          postRechargeApply({...requestParamter}).then(res => {
            this.$data.btnLoading = false
            if(res.ret == 0) {
              _me.$data.succ = true
            } else {
              _me.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          }).catch( error => {
            _me.$data.btnLoading = false
          })
        } else {
          let _msg = '请按要求填写正确的转账信息'
          if(!requestParamter.voucher) {
            _msg = '请上传转账凭证'
          }
          this.$message({
            message: _msg,
            type: 'warning'
          });
        }
      })      
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  padding: 20px;
  .title {
    font-family: 'MicrosoftYaHei';
    font-size: 16px;
    color: #666;
    line-height: 40px;
    border-bottom: 1px solid #eee;
  }
  .account-info {
    display: inline-block;
    background: #FBFBFB;
    border: 1px dashed #D2D6DE;
    margin: 10px 0;
    font-family: 'MicrosoftYaHei';
    font-size: 14px;
    color: #333;
    line-height: 30px;
    padding: 20px;
    min-width: 498px;
    .label {
      display: inline-block;
      width: 80px;
      text-align: right;
    }
    .value {
      padding-left: 10px;
    }
  }
}
.tips {
  font-family: 'MicrosoftYaHei';
  font-size: 12px;
  color: #999;
}
</style>
<style lang="scss">
.form {
  padding: 20px;
  margin: 10px 0;
  .form-input {
    width: 360px;
  }
  .form-upload {
    .el-upload, .is-success, .is-ready, .is-uploading {
      width: 100px;
      height: 100px;
      line-height: 100px;
      .el-icon-upload-success {
        position: relative;
        top: -35px;
      }
    }
  }
  .form-submit {
    text-align: center;
    margin: 20px 0;
    width: 480px;
  }
}
</style>


// WEBPACK FOOTER //
// recharge.vue?4740d730